import { object, string } from 'yup';

export const destroyValidation = () =>
  object().shape({
    destructionReason: string().required('Destruction Reason is required')
  });

export const destroyDefaults = ({
  destructionReason = ''
} = {}) => ({
  destructionReason
});
